export type WithdrawalConfirmationTranslations = {
  title: string;
  subtitle: string;
  okGotIt: string;
  viewDetails: string;
};

const withdrawalConfirmationTranslationKeys: WithdrawalConfirmationTranslations =
  {
    title: 'fiat_withdrawal_success_title',
    subtitle: 'fiat_withdrawal_success_subtitle',
    okGotIt: 'ok_got_it_button',
    viewDetails: 'view_details',
  };

export const getWithdrawalConfirmationTranslations = (
  t: (key: string, options?: Record<string, string>) => string,
  recipientName: string,
  formattedAmount: string | null,
): WithdrawalConfirmationTranslations => ({
  title: t(withdrawalConfirmationTranslationKeys.title),
  subtitle: t(withdrawalConfirmationTranslationKeys.subtitle, {
    amount: formattedAmount ?? '',
    name: recipientName,
  }),
  okGotIt: t(withdrawalConfirmationTranslationKeys.okGotIt),
  viewDetails: t(withdrawalConfirmationTranslationKeys.viewDetails),
});
